import React from 'react';
import Landing from './components/Landing';

const App: React.FC = () => {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}

export default App; 